<template>
  <div v-if="type == 'full'">
    <div class="progress">
      <div
        class="progress-bar progress-bar-striped"
        role="progressbar"
        :style="'width: ' + progressPct + '%;'"
        :aria-valuenow="progress"
        aria-valuemin="0"
        :aria-valuemax="total"
      >
        {{ progressPct | number('0') }}%
      </div>
    </div>
  </div>
  <div v-else>
    <div class="slim-progress">
      <div
        class="slim-progress-bar progress-bar-striped bg-info"
        :style="'width: ' + progressPct + '%'"
      ></div>
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'ProgressBar',
  props: ['type'],

  data () {
    return {}
  },
  computed: {
    total () {
      return store.progress.total
    },
    progress () {
      return store.progress.completed
    },
    progressPct () {
      return (store.progress.completed / store.progress.total) * 100
    }
  }
}
</script>

<style scoped>
.slim-progress {
  width: 100%;
  height: 0.25em;
}

.slim-progress-bar {
  height: 100%;
}

.progress {
  font-size: 0.75rem;
  height: 1rem;
}

.progress-bar {
  background-color: rgba(52, 152, 219, 0.46);
  color: #222277;
}
</style>
